import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { PATHS } from 'src/app/app-routing.module';
import { TableStateService } from '../../services/table-state.service';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
    baseUrl = '/user/login';

    constructor(private router: Router, private tableStateService: TableStateService) {}

    private handleAuthError(err: HttpErrorResponse): Observable<any> {
        if (err.status === 403 || err.status === 401) {
            // Clear all filters and table states before clearing all localStorage
            this.clearAllFilters();
            localStorage.clear();
            this.router.navigate(['/login']);
            return throwError(err); // Return observable with error
        }
        return throwError(err);
    }

    /**
     * Clear all filters from localStorage and sessionStorage
     */
    private clearAllFilters(): void {
        // Clear table state history and table states
        localStorage.removeItem('tableStateHistory');
        this.tableStateService?.clearAllStates();

        // Clear filter-related localStorage items
        localStorage.removeItem('filter');
        localStorage.removeItem('tabs');
        localStorage.removeItem('tabHistory');

        // Clear filter-related sessionStorage items
        sessionStorage.removeItem('productFilters');
        sessionStorage.removeItem('redirectNav');

        // Clear all table_state_* keys from sessionStorage (if any remain)
        try {
            const keysToRemove: string[] = [];
            for (let i = 0; i < sessionStorage.length; i++) {
                const key = sessionStorage.key(i);
                if (key && key.startsWith('table_state_')) {
                    keysToRemove.push(key);
                }
            }
            keysToRemove.forEach((key) => sessionStorage.removeItem(key));
        } catch (error) {
            console.error('Error clearing table state keys from sessionStorage:', error);
        }
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.url !== this.baseUrl) {
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : '';
            //
            if (token === '') {
                token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
            }
            if (
                request.url.includes('user/') ||
                request.url.includes('personnemorale/') ||
                request.url.includes(PATHS.product) ||
                request.url.includes('elk/') ||
                request.url.includes('assets/mock-apis') ||
                request.url.includes('produit/') ||
                request.url.includes('dynamic_document_info/') ||
                request.url.includes('dynamic_documents/') ||
                request.url.includes('dynamic-documents/') ||
                request.url.includes('resource-files/') ||
                request.url.includes('dynamic-document-infos/') ||
                request.url.includes('entite/') ||
                request.url.includes('template/') ||
                request.url.includes('email/') ||
                request.url.includes('view/') ||
                request.url.includes('parametre/') ||
                request.url.includes('retrievepassword/reset') ||
                request.url.includes('resource-files-redirect')
            ) {
                return next.handle(request);
            }

            // Add exclusion for specific routes (static assets, mock-apis, etc.)
            const excludedRoutes = [
                'assets/mock-apis',
                'resource-files/',
                'resource-files-redirect/',
                'produit/',
                'dynamic_document_info/',
                'dynamic_documents/',
                'dynamic-documents/',
                'dynamic-document-infos/',
                'entite/',
                'template/',
                'email/',
                'view/',
                'parametre/',
                'ironside-resources',
                'retrievepassword/reset',
            ];

            const isExcluded = excludedRoutes.some((route) => request.url.includes(route));

            // Apply token only if not in excluded routes
            if (token && !isExcluded) {
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`,
                    },
                });
            }
        }

        return next.handle(request).pipe(
            catchError((err) => {
                return this.handleAuthError(err);
            })
        );
    }
}
